import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {EditModuleDialogComponent} from './edit.module.dialog.component';

const routes = [{path: 'moduledialog', component: EditModuleDialogComponent}];

@NgModule({
  declarations: [EditModuleDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [EditModuleDialogComponent]
})

export class EditModuleDialogModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/edit/edit.module.dialog.module.ts